const minLength = min => value => {
  return value && value.length < min ? `Must be ${min} characters or more` : undefined
  return undefined;
}

export default minLength;